import { ConfigProvider, TimePicker, TimePickerProps } from 'antd';
import './styles.scss';
import classNames from 'classnames';

export type CustomTimePickerProps = Omit<TimePickerProps, 'mode'> & {
  width?: number | string;
};

const CustomTimePicker = (props: CustomTimePickerProps) => {
  const { style, width, className, popupClassName, ...rest } = props;

  const newStyle = { ...style, width };

  return (
    <ConfigProvider>
      <TimePicker
        {...rest}
        style={newStyle}
        popupClassName={classNames(
          'custom-time-picker-dropdown',
          popupClassName,
        )}
        className={classNames('custom-time-picker', className)}
      />
    </ConfigProvider>
  );
};

export default CustomTimePicker;
